/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { formatDate } from '../../data/utils/formatDate';
import { getConfiguration } from '../../data/utils/configuration';
import { oddToString } from '../../data/utils/oddToString';
import { labels } from '../../data/labels';
import AmountBetslipForm from './AmountBetslipForm';
import StakesPicker from './StakesPicker';

function getBetKey(couponKey, container, event, bet) {
    return `bet-draw-sel-${couponKey}-container-${container}-pal-${event.pal}-avv-${event.avv}-scom-${bet.scomSogei}_${bet.handicap}-draw-${bet.draw}`;
}

function CouponEvent(props) {
    const conf = getConfiguration();
	const bankerEnabled = conf.sybe != null? conf.sybe : true;
    const betslipContext = React.useContext(BetslipContext) ;
	const betslipData = betslipContext.getBetslipData();

    function deleteSelection(scomSogei, handicap, codDraw, removeAllBets) {
    	if (removeAllBets) {
    		scomSogei = null;
    		codDraw = null;
    		handicap = null;
    	}
    	betslipContext.toggleSelectionBetslip(event.pal, event.avv, null, null, null, scomSogei, handicap, null, codDraw, null, null);
    }

    function deleteBet() {
        if (tabSingle || (tabMulti && event.bets[0].legabile)) {
            const bet = event.bets[0];
            deleteSelection(bet.scomSogei, bet.handicap, bet.draw, false);	
        } else {
            deleteSelection(null, null, null, true);		
        }
    }
    
    function toggleBanker() {
    	if(bankerEnabled){
    		event.banker = !event.banker;
    		betslipContext.setBetslipData(betslipData, true);    		
    	}
    }
	
	const couponKey = props.couponKey;
    let alias = props.selection.alias;
    alias = alias == null ? '' : alias + ' ';
    const container = props.container;
    let tabSingle = container === 'singlebets';
    let tabMulti = container === 'multibets';
    
    let event = props.selection;
    
    let descSportTournament = null;
    if (props.selection.descSport?.length > 0) {
    	descSportTournament = props.selection.descSport;
    }
    
    if (props.selection.descTournament?.length > 0) {
    	if (descSportTournament == null) {
    		descSportTournament = props.selection.descTournament;
    	} else {
    		descSportTournament = `${descSportTournament} - ${props.selection.descTournament}`;
    	}
    }
    
    const parts = event.descEvent.split(" - ");
    let homeTeam = parts[0];
    let awayTeam = parts[1];
    
    let bets = event.bets;
    // restoring the bets array: if it is not a systembet, then I will draw just the first bet
    if (container !== 'systembets') {
    	let aux = [];    
    	if (bets.length > 0) {
    		aux.push(bets[0]);
    	}
    	bets = aux;
    }
   
    let blinkElement = false;
    if (event.closed == null || event.closed == false) {
    	for (let km in event.bets) {
    		blinkElement = blinkElement || (event.bets[km].updated != null || event.bets[km].closed); 
    	}
    } else {
    	blinkElement = true;
    }

    blinkElement = false; // TODO: check if we need another effect
    return (
        <div className={"evento-schedina" + (blinkElement? ' blink': '')}>
            <div className="grid-schedina grid-schedina-mobile grid-schedina-singola">
				{event.closed &&
					<div className="eventClosed">{labels['betslip.event.event_closed']}</div>
				}
                <div className="grid-schedina-intestazione">
                    <div className="grid-schedina-intestazione_contenitore-testo">
                        {descSportTournament &&
                            <p>{descSportTournament}</p>
                        }
                    </div>
                    <div className="grid-schedina-intestazione_container-bottoni">
                        {container === 'systembets' && bankerEnabled && 
                            <label className="custom-switch-2">
                                <input type="checkbox" checked={event.banker} onChange={() => toggleBanker()} />
                                <div className="custom-switch-2-text">{labels['systembet.fixed_char']}</div>
                                <span className="custom-slider-2 round"></span>
                            </label>
                        }
                        {event.isLive &&
                            <div className="grid-schedina_bottone-live">
                                <p>Live</p>
                            </div>
                        }
                        <button className="grid-schedina_bottone-generico" onClick={deleteBet}><i className="fas fa-trash-alt fa-lg"></i></button>
                    </div>
                </div>
                {conf.sbst &&
                    <div className="grid-schedina-intestazione">
                        <div className="grid-schedina-intestazione_contenitore-testo">
                            <p>{formatDate(event.timestamp).formatted}</p>
                        </div>
                    </div>
                }
                <div className="grid-schedina-body">
                    <div className="grid-schedina-body_evento">
                        {alias &&
                            <div className="grid-schedina-body_evento_alias">
                                <p>{alias}</p>
                            </div>
                        }
                        <div className="grid-schedina-body_evento_nome-squadra">
                            <p>{homeTeam}</p>
                        </div>
                        {awayTeam != null &&
                            <>
                                <div className="grid-schedina-body_evento_separatore">
                                    <p>-</p>
                                </div>
                                <div className="grid-schedina-body_evento_nome-squadra">
                                    <p>{awayTeam}</p>
                                </div>
                            </>
                        }
                    </div>
                    <div className="grid-schedina-body_quote">
                        {bets.map(bet => {
                            let reactKey = getBetKey(couponKey, container, event, bet);
                            let playabilityIssue = null;
							if(container === 'multibets' && (bet.minPlError || bet.maxPlError) ){
								let minPl = bet.minPl? bet.minPl : 1;
								let maxPl = bet.maxPl? bet.maxPl : (conf.meb? conf.meb:30);
								if(minPl > 1){
									minPl --;
								}
								if(maxPl > 1){
									maxPl --;										
								}
								playabilityIssue = labels['playability.min_max_issue'];
								playabilityIssue = playabilityIssue.replaceAll('{{MIN_SEL}}', minPl);
								playabilityIssue = playabilityIssue.replaceAll('{{MAX_SEL}}', maxPl);
							}
							if(container === 'multibets' && !playabilityIssue && bet.minOddError){
								playabilityIssue = labels['playability.min_odd_issue'];
								playabilityIssue = playabilityIssue.replaceAll('{{MIN_ODD}}', oddToString(bet.minOddError));
							}
							
							if(container === 'singlebets' && bet.minPlError){
								let minPl = bet.minPl? bet.minPl : 1;
								if(minPl > 1){
									minPl --;
								}
								playabilityIssue = labels['playability.min_issue'];
								playabilityIssue = playabilityIssue.replaceAll('{{MIN_SEL}}', minPl);
							}
                            return (
                                <React.Fragment key={reactKey}>
	           						{
										playabilityIssue  && <div className="playabilityIssue">
											{playabilityIssue}
										</div>
									}
                                    {tabSingle && conf.bak?.mob === true &&
                                        <StakesPicker couponKey={couponKey} 
                                                      isEventForm={true} 
                                                      pal={event.pal} 
                                                      avv={event.avv}
                                                      scomSogei={event.bets[0].scomSogei}
                                                      handicap={event.bets[0].handicap}
                                                      draw={event.bets[0].draw}/>
                                    }
 
                                    <div className={"grid-schedina-body_quote-riga" + (bet.closed? ' opacityEventClosed' : '')}>

                                    	<div className="grid-schedina-body_quote-riga_descrizione-quota">
                                            <p>{bet.descBet}: <span>{bet.descDraw}</span></p>
                                            {bet.updated != null &&
                                                <span className={"variationDesc grassetto " + (bet.updated === 'increased'? ' verde':' rosso')}>{labels['betslip.var_quota']}</span>
                                            }
                                        </div>
                                        <div className={"grid-schedina-body_quote-riga_valore-quota"}>
                                            <p className={"no-ellipsis" + (bet.updated != null? (bet.updated === 'increased'? ' verde':' rosso') : '')}>
                                            	{bet.closed ? labels['general.giocabilita_chiusa'] : oddToString(bet.odd)}
												{bet.updated != null &&
                                                    <span className={"arrow-" + (bet.updated === 'increased'? 'up':'down')}> </span>
												}
                                            </p>
                                        </div>
                                        {tabSingle &&
                                            <AmountBetslipForm container={container} 
                                                               couponKey={couponKey} 
                                                               isEventForm={true} 
                                                               pal={event.pal} 
                                                               avv={event.avv}
                                                               scomSogei={event.bets[0].scomSogei}
                                                               handicap={event.bets[0].handicap}
                                                               draw={event.bets[0].draw} />
                                        }
                                        {container === 'systembets' && bets.length > 1 &&
                                            <button className="grid-schedina-body_quote-riga_elimna-quota grid-schedina_bottone-generico" onClick={() => deleteSelection(bet.scomSogei, bet.handicap, bet.draw, false)}>
                                                <i className="fas fa-times"></i>
                                            </button>
                                        }
                                    </div>
                                </React.Fragment>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CouponEvent;